import { Link } from 'react-router'
import {
  AppLayout,
  Mtds,
  ScreenHeader,
  ScreenLayout,
  TopBar
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'

export function NotFoundScreen() {
  return (
    <AppLayout
      useMobileBar={false}
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Fant ikke siden' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Fant ikke siden'
            description={
              <p>Adressen kan være feil, eller siden kan ha blitt flyttet.</p>
            }
          />
        }
      >
        <Mtds.Button as={Link} to='/home' data-variant='primary'>
          Gå til oversikten
        </Mtds.Button>
      </ScreenLayout>
    </AppLayout>
  )
}
